module.exports = __webpack_public_path__ + "media/app/assets/races/worgen_female-5c5d50083a532dcaced54cb39b24b1b0.png";